export enum MarketplaceAssetFilter {
  ALL = 'all',
  ONLY_ON_SALE = 'sale',
}

export enum MarketplaceOrderFilter {
  PRICE_ASC = 'price_asc',
  PRICE_DES = 'price_des',
}

export interface KeyValueType {
  [key: string]: string
}
export type Filter = Partial<{
  /** Free text */
  open?: string
  rarity: string | null
  trait: KeyValueType | null
}>

export type MarketplaceFilter = Partial<
  Filter & {
    currency?: string
    asset: MarketplaceAssetFilter
    order: MarketplaceOrderFilter
    sold: boolean
  }
>

export interface TraitType {
  trait_type: string
  value: string
}

export type OptionsShape = {
  label: string
  value: string
}

type DeepNode = {
  [k: string]: DeepNode | number
}
export type FirestoreGraphFilter = {
  attributes: string[]
  graph: DeepNode
}